module.exports = __webpack_public_path__ + "img/bg_function03_3_m.34805bdd.png";